import axios from 'portal/utils/axios-msal'
import _ from 'lodash'

export async function putRecord(
  accountId,
  projectId,
  moduleName,
  record,
  isImperial
) {
  const uri =
    '/accounts/' +
    accountId +
    '/projects/' +
    projectId +
    '/modules/' +
    moduleName.toLowerCase() +
    '/records/' +
    record.recordId +
    (isImperial && moduleName.toLowerCase() === 'delivery' ? '/imperial' : '')

  // If Waste record, for each item in the record set volume, weight, estimatedVolume & estimatedWeight to contain value & unit
  let clonedItems = []
  if (moduleName.toLowerCase() === 'waste' && record.data.items) {
    clonedItems = record.data.items.map(item => {
      const clonedItem = _.cloneDeep(item)

      if (clonedItem.volume) {
        clonedItem.volume = [
          {
            value: clonedItem.volume,
            unit: isImperial ? 'CubicYard' : 'CubicMeter'
          }
        ]
      } else if (!clonedItem.volume) {
        clonedItem.volume = []
      }

      if (clonedItem.weight) {
        clonedItem.weight = [
          {
            value: clonedItem.weight,
            unit: isImperial ? 'Pound' : 'Tonne'
          }
        ]
      } else if (!clonedItem.weight) {
        clonedItem.weight = []
      }

      // If measurementVolume or measurementWeight exists remove them
      delete clonedItem.measurementVolume
      delete clonedItem.measurementWeight

      return clonedItem
    })
  }

  return await axios.put(
    uri,
    { ...record, data: { ...record.data, items: clonedItems } },
    {
      validateStatus: status => status === 201,
      params: isImperial ? { responseUnitType: 'Imperial' } : {}
    }
  )
}
